import React, { cloneElement } from 'react';
import { Draggable } from 'react-beautiful-dnd';

const DraggableTab = (props) => {
  return (
    <Draggable draggableId={`${props.index}`} index={props.index} disableInteractiveElementBlocking>
      {(draggableProvided) => (
        <div ref={draggableProvided.innerRef} {...draggableProvided.draggableProps}>
          {cloneElement(props.child, {
            ...props,
            ...draggableProvided.dragHandleProps,
            style: { cursor: 'inherit' },
          })}
        </div>
      )}
    </Draggable>
  );
};

export default DraggableTab;
